

































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import TravelTag from "@/components/travel/TravelTag.vue";
import TravelPoint from "@/components/travel/TravelPoint.vue";
import TravelBudget from "@/components/travel/TravelBudget.vue";
import TravelGallery from "@/components/travel/TravelGallery.vue";
import IconCustom from "@/components/lib/IconCustom.vue";
import ButtonCommon from "@/components/lib/ButtonCommon.vue";
import onLocaleChangeMixin from "@/mixins/onLocaleChangeMixin";
import { updateItem, updateItems } from "@/lib";
import { onLoadJumpMixin } from "@/mixins/onScrollAnimationMixin";
import { resolveTravelImageMixin } from "@/mixins/resolveImageMixin";
import {
  IBudget,
  IImage,
  IImageSimple,
  ImageSimple,
  IPoint,
  ISolution,
  IStep,
  ITag,
  ITravel,
  SolutionComposition,
} from "@/entities";
import { ITravelAdditions } from "@/entities/travel/additions/travelAdditions";
import i18n from "@/i18n";
import { isEqual } from "lodash";
import MapBox from "../components/MapBox.vue";
const NotFoundContent = () => import("@/components/NotFoundContent.vue");
const TravelAlternativeLink = () =>
  import("@/components/travel/TravelAlternativeLink.vue");
const TravelDescribeMenu = () =>
  import("../components/travel/TravelDescribeMenu.vue");
const EmailForm = () => import("@/components/contact/EmailForm.vue");

@Component({
  components: {
    TravelTag,
    TravelPoint,
    TravelBudget,
    TravelGallery,
    IconCustom,
    ButtonCommon,
    MapBox,
    NotFoundContent,
    TravelAlternativeLink,
    TravelDescribeMenu,
    EmailForm,
  },
  filters: {
    strToLowerCase: (str: string): string => {
      return str.toLowerCase();
    },
  },
})
export default class Travel extends Mixins(
  onLoadJumpMixin,
  resolveTravelImageMixin,
  onLocaleChangeMixin
) {
  private conditionToShow = false;
  private data?: ITravel | null = null;

  mounted() {
    this.$store.dispatch("setCheckboxLabelColor", false);
  }

  get isIndividualTravel(): boolean {
    return isEqual(this.data?.travel_format, "individual");
  }

  get getIsShowEmailFormActive() {
    return this.$store.getters.getEmailModalCondition;
  }

  get travel(): ITravel | null | undefined {
    return this.data;
  }

  protected initFetches = [this.fetchTravelData];

  protected reFetches = [this.updateTravel, this.updateSolutions];

  private solutions: ISolution[] = [];

  get budgets(): IBudget[] {
    return (
      this.data?.budgets?.filter((b) => b.budget_from || b.budget_to) || []
    );
  }

  get relatedSolution(): ISolution | undefined {
    return this.solutions.length ? this.solutions[0] : undefined;
  }

  get solutionComposition(): string {
    const solution = this.relatedSolution;
    if (solution) {
      // collect solution services by type
      let composition = new SolutionComposition();
      solution.service.forEach((s) => {
        const type = s.service_type_priced.service_type.type;
        let limit = s.limit;
        limit = limit === undefined ? 1 : limit;
        if (["consultation", "plan"].includes(type)) {
          (composition as any)[type] =
            (composition as any)[type] === 0
              ? 0
              : ((composition as any)[type] || 0) + limit;
        } else {
          const name = s.service_type_priced.service_type.name;
          composition.services[name] =
            composition.services[name] === 0
              ? 0
              : (composition.services[name] || 0) + limit;
        }
      });
      // string to update
      let services: string[] = [];
      let root: string[] = [];
      root.push(
        this.$tc(`services.solutions.plan`, composition.plan).toLowerCase()
      );
      root.push(
        this.$tc(
          `services.solutions.consultation`,
          composition.consultation
        ).toLowerCase()
      );
      Object.keys(composition.services).forEach((key) => {
        const limit = composition.services[key];
        services.push(
          key +
            (limit === 1 ? "" : ` (${limit ? limit : this.$t("unlimited")})`)
        );
      });
      root.push(...services);
      return this.$options?.filters?.capitalize(root.join(", "));
    } else {
      return "";
    }
  }

  private pointsLimit: number = 4;

  get haveBudgets(): boolean {
    return !!this.data?.budgets?.length;
  }

  get points(): IPoint[] {
    let sortedSteps = this.travel?.steps?.sort(
      (a: IStep, b: IStep) => a.position - b.position
    );
    return (
      sortedSteps?.reduce((res: IPoint[], step: IStep) => {
        return [...res, ...(step.points || [])];
      }, []) || []
    );
  }

  get pointsToShow(): IPoint[] {
    return this.points.slice(0, this.pointsLimit);
  }
  get coords(): number[][] {
    let coords: number[][] = [];
    this.pointsToShow.map((point: IPoint) => {
      if (!!point.latitude && !!point.longitude) {
        coords.push([point.longitude, point.latitude]);
      }
    });
    return coords;
  }

  get tagsToShow(): ITag[] | undefined {
    let toShow = [
      "accommodation",
      "locations",
      "travel_type",
      "taste",
      "season",
      "tourist",
      "travel_format",
    ];

    return this.travel?.tags?.filter(
      (tag: ITag) => toShow.indexOf(tag.name) !== -1
    );
  }
  formattedDate(date: string) {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    return new Date(date)
      .toLocaleDateString("en-GB", options)
      .replace(/\//g, ".");
  }

  get infoSingleDate(): string {
    let res = "";
    let travel = this.travel;
    let from = travel?.travel_additions?.date_from;
    let to = travel?.travel_additions?.date_to;

    res +=
      this.$t("travel.info.individualDate") +
      " " +
      this.formattedDate(from!) +
      " - " +
      this.formattedDate(to!);
    return res;
  }

  get infoSingle(): string {
    let res = "";
    let travel = this.travel;
    let min = 0; //travel?.tourist_min;
    let max = travel?.tourist_max;
    let duration = travel?.duration_days;

    let haveTouristLimit = min || max;
    if (duration || haveTouristLimit) {
      res = this.$t("travel.info.pre") as string;
      if (haveTouristLimit) {
        res += " ";
        if (min && max) {
          res += this.$t("people-for") + " ";
          if (min !== max) {
            res += min + "-";
          }
          res += max + " " + this.$tc("travel.info.tourists", max);
        } else {
          res += "- ";
          if (min) {
            res +=
              this.$t("from") +
              " " +
              min +
              " " +
              this.$tc("travel.info.tourists", 0);
          } else {
            res +=
              this.$t("lim-to") +
              " " +
              max +
              " " +
              this.$tc("travel.info.tourists", 0);
          }
        }
      }
      if (duration) {
        let conditionDays = 0;
        switch (true) {
          case duration > 1 && duration <= 4:
            conditionDays = 2;
            break;
          case isEqual(duration, 1):
            conditionDays = 1;
            break;
        }

        res +=
          " " +
          this.$t("travel.info.duration") +
          " " +
          duration +
          " " +
          this.$tc("days", conditionDays);
      }
    }
    return res;
  }

  get groupIndInfo(): string {
    let res = "";
    let travel = this.travel;
    let deference!: number;
    let tcConditionNight = 0;
    let tcConditionDays = 0;

    if (
      travel?.travel_additions?.date_to &&
      travel.travel_additions.date_from
    ) {
      deference = Math.ceil(
        (new Date(travel?.travel_additions?.date_to).getTime() -
          new Date(travel.travel_additions.date_from).getTime()) /
          (1000 * 60 * 60 * 24)
      );
    }

    switch (true) {
      case deference - 1 === 0:
        tcConditionNight = 0;
        tcConditionDays = 1;
        break;
      case deference - 1 > 4:
        tcConditionNight = 0;
        tcConditionDays = 0;
        break;
      case deference - 1 === 1:
        tcConditionNight = 1;
        tcConditionDays = 2;
        break;
      case deference - 1 === 2 || deference - 1 === 3:
        tcConditionNight = 2;
        tcConditionDays = 2;
        break;
      case deference - 1 === 4:
        tcConditionNight = 2;
        tcConditionDays = 0;
        break;
    }

    res = this.$t("travel.info.groupIndPre") as string;
    // res += `${travel?.tourist_max} ` + this.$tc('travel.info.participants', 0) + ' - ';
    // res += `${deference} ` + this.$tc('travel.info.days', tcConditionDays) + '/' + `${deference - 1} ` + this.$tc('travel.info.nights', tcConditionNight);
    res += this.travelDate;

    return res;
  }

  private updateTravel(): void {
    let travel = this.data;
    if (travel) {
      updateItem<ITravel>(travel, this.$storage.actions.getTravelById);
    }
  }

  private updateSolutions(): void {
    updateItems(this.solutions, this.$storage.actions.getSolutionById);
  }

  get images(): IImageSimple[] {
    let travel = this.travel;
    if (travel) {
      let toShow =
        travel?.images?.reduce((gallery: IImageSimple[], image: IImage) => {
          return image.file === travel?.general_image.file
            ? gallery
            : [...gallery, new ImageSimple(image)];
        }, []) || [];
      return [new ImageSimple(travel.general_image), ...toShow];
    } else {
      return [];
    }
  }

  private notFound: boolean = false;

  private overlay =
    "linear-gradient(180deg, #1F1515 10%, rgba(31, 21, 21, 0.9) 51.04%, rgba(31, 21, 21, 0.5) 100%)";

  get price(): string | undefined {
    let travel = this.data;
    return travel
      ? this.$storage.getters.getPriceLabel(travel.price)
      : undefined;
  }

  private fetchTravelById(): Promise<ITravel | undefined> {
    let id = parseInt(this.$route.params.id);

    return this.$storage.actions.getTravelById(id);
  }

  private preFetchTravelById(): Promise<ITravel> {
    return new Promise<ITravel>((resolve, reject) => {
      let travel = this.$storage.getters.getTravel();
      if (travel) {
        resolve(travel);
      } else {
        this.fetchTravelById().then((res) => {
          if (res) {
            resolve(res);
          } else {
            reject();
          }
        });
      }
    });
  }

  private fetchTravelData(): void {
    this.preFetchTravelById()
      .then((travel) => {
        if (travel && isEqual(travel.travel_format, "group")) {
          this.conditionToShow = true;
        }

        this.data = travel;
        this.getRelatedSolutions();
      })
      .catch(() => {
        this.notFound = true;
      });
  }

  private getRelatedSolutions(): void {
    this.$storage.actions
      .fetchSolutions({
        category: this.data?.category,
      })
      .then((res) => {
        this.solutions = res;
      });
  }

  private buyPlan(): void {
    // open order modal with travel subject
    this.$storage.actions.setModal({
      name: "ModalPlanPublic",
      subject: this.data,
      from: "travel",
    });
  }

  private getSolution(): void {
    // open order modal with solution subject
    this.$storage.actions.setModal({
      name: "ModalSolution",
      subject: {
        ...this.relatedSolution,
        travel: this.data, // travel guide to include in solution
      },
      from: "travel",
    });
  }

  private getConsultation(): void {
    // open consultation ordering modal
    this.$storage.actions.setModal({
      name: "ModalConsultation",
      from: "travel",
    });
  }

  private getCustomPlan(): void {
    // open custom plan ordering modal
    this.$storage.actions.setModal({
      name: "ModalPlan",
      from: "travel",
      subject: {
        reference: this.travel,
      },
    });
  }

  private bookingTravel(): void {
    this.$store.dispatch("setEmailModalCondition", true);
  }

  private linkTelegram(): void {
    window.open("https://t.me/bonifiquelife/");
  }

  get travelDate(): string | undefined {
    let res = "";
    let currentGroupTravelAdditions!: ITravelAdditions;
    currentGroupTravelAdditions = this.$store.getters.getGroupTravelAdditions;

    if (currentGroupTravelAdditions) {
      if (
        currentGroupTravelAdditions.date_from &&
        currentGroupTravelAdditions.date_to
      ) {
        let datesOptionsFrom: any = {};
        let datesOptionsTo: any = {};

        if (
          isEqual(
            new Date(currentGroupTravelAdditions.date_from).getMonth(),
            new Date(currentGroupTravelAdditions.date_to).getMonth()
          )
        ) {
          datesOptionsFrom = { day: "numeric" };
          datesOptionsTo = { month: "long", day: "numeric" };
        } else {
          datesOptionsFrom = { day: "numeric", month: "long" };
          datesOptionsTo = { day: "numeric", month: "long" };
        }

        if (
          isEqual(
            new Date(currentGroupTravelAdditions.date_from).getFullYear(),
            new Date(currentGroupTravelAdditions.date_to).getFullYear()
          )
        ) {
          Object.assign(datesOptionsTo, { year: "numeric" });
        } else {
          Object.assign(datesOptionsFrom, { year: "numeric" });
          Object.assign(datesOptionsTo, { year: "numeric" });
        }

        res = `${new Date(
          currentGroupTravelAdditions.date_from
        ).toLocaleDateString(i18n.locale, datesOptionsFrom)}
             - ${new Date(
               currentGroupTravelAdditions.date_to
             ).toLocaleDateString(i18n.locale, datesOptionsTo)}`;
      }
    }

    return res;
  }

  private async getTravelDates(): Promise<ITravelAdditions> {
    let currentAdditions!: ITravelAdditions;

    await this.fetchTravelById().then((travel) => {
      if (travel?.travel_additions) {
        currentAdditions = travel?.travel_additions;
      }
    });

    return currentAdditions;
  }
}
